import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Spin, Typography } from "antd";
import snakecaseKeys from "snakecase-keys";
import { AuthInfo } from "stores/slices/auth";
import { doGetWorkspacePage } from "stores/slices/workspace";

import BulkSMSCreditBalance from "components/bulkSMSCreditBalance";
import AppButton from "components/button";
import SelectMultiple from "components/inputs/selectSearchSingle";

import AppSelect from "../../../components/inputs/select";
import {
  CHANNEL_NAME,
  CHANNEL_PROVIDER,
  CHANNEL_STATUS,
  PATTERNS,
  USER_TYPE,
} from "../../../constants/appConstant";
import {
  doCreateChannel,
  doGetChannelDetail,
  doUpdateChannel,
} from "../../../stores/slices/channel";

import styles from "../../../components/styles.module.scss";

const { Link } = Typography;
const ChannelForm = props => {
  const {
    isViewFrm,
    itemSelected,
    onCancel,
    onSuccess,
    onChangeViewFrm,
    loadingList,
    setLoadingList,
    userType,
  } = props;

  const formRef = React.useRef(null);

  const { t } = useTranslation();
  const [isView, setIsView] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [dataDetail, setDataDetail] = useState();

  const [listAllWorkspace, setListAllWorkspace] = useState([]);
  const [totalWorkspacePages, setTotalWorkspacePages] = useState(0);
  const [workspacecQueries, setWorkspaceQueries] = useState({
    pageNumber: 1,
    pageSize: 10,
    statuses: ["ACTIVE"],
    sortFieldWorkspace: "createdTime",
  });
  const [workspaceOption, setOptionWorkspace] = useState([]);

  const authInfo = useSelector(AuthInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    if (userType === USER_TYPE.SUPER_ADMIN) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  }, []);

  const channelNameOptions = [
    {
      value: CHANNEL_NAME.BULKSMS,
      label: t("channelName.BULKSMS"),
    },
  ];
  const providerOptions = [
    {
      value: CHANNEL_PROVIDER.SMS,
      label: t("channelProvider.sms"),
    },
    {
      value: CHANNEL_PROVIDER.MMS,
      label: t("channelProvider.mms"),
    },
    {
      value: CHANNEL_PROVIDER.WhatsApp,
      label: t("channelProvider.whatsapp"),
    },
    {
      value: CHANNEL_PROVIDER.Voice,
      label: t("channelProvider.voice"),
    },
  ];
  const statusOptions = [
    {
      value: CHANNEL_STATUS.ENABLED,
      label: t("channelStatus.ENABLED"),
    },
    {
      value: CHANNEL_STATUS.DISABLED,
      label: t("channelStatus.DISABLED"),
    },
  ];

  const onFinish = async fieldsValue => {
    const params = {
      name: fieldsValue["name"],
      sms:
        fieldsValue["provider"] &&
        fieldsValue["provider"].indexOf(CHANNEL_PROVIDER.SMS) !== -1,
      mms:
        fieldsValue["provider"] &&
        fieldsValue["provider"].indexOf(CHANNEL_PROVIDER.MMS) !== -1,
      whatsapp:
        fieldsValue["provider"] &&
        fieldsValue["provider"].indexOf(CHANNEL_PROVIDER.WhatsApp) !== -1,
      voice:
        fieldsValue["provider"] &&
        fieldsValue["provider"].indexOf(CHANNEL_PROVIDER.Voice) !== -1,
      apiKey: fieldsValue["apiKey"],
      status: fieldsValue["channelStatus"],
    };
    setLoading(true);
    if (fieldsValue["workspace"]) {
      params.workspaceId = fieldsValue["workspace"];
    }

    if (itemSelected) {
      params.id = itemSelected.id;
      const { payload } = await dispatch(
        doUpdateChannel(snakecaseKeys(params))
      );
      if (payload && payload.status === 200) {
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
      }
    } else {
      const { payload } = await dispatch(
        doCreateChannel(snakecaseKeys(params))
      );
      if (payload && payload.status === 200) {
        setLoading(false);
        onSuccess();
      } else {
        setLoading(false);
      }
    }
  };

  const validateMessages = {
    required: t("validate.required"),
  };

  const fetchListWorkspace = async request => {
    const newRequest = {
      ...request,
      pageNumber: request.pageNumber,
      pageSize: request.pageSize,
      statuses: ["ACTIVE"],
      sortFieldWorkspace: "createdTime",
    };
    if (
      totalWorkspacePages > 0 &&
      totalWorkspacePages < newRequest.pageNumber
    ) {
      return;
    }
    if (request.isReset) {
      setOptionWorkspace([]);
      setListAllWorkspace([]);
      delete newRequest.isReset;
    }
    setLoadingList(true);
    const { payload } = await dispatch(doGetWorkspacePage(newRequest));
    if (payload && typeof payload !== "string") {
      if (request.isReset) {
        setListAllWorkspace(removeDuplicates([...payload.content]));
      } else {
        setListAllWorkspace(
          removeDuplicates([...listAllWorkspace, ...payload.content])
        );
      }
      setTotalWorkspacePages(payload.totalPages);
      setWorkspaceQueries(newRequest);
    }
    setLoadingList(false);
  };
  const removeDuplicates = arr => {
    return arr.filter(
      (ele, ind) => ind === arr.findIndex(elem => elem.id === ele.id)
    );
  };

  useEffect(() => {
    if (listAllWorkspace && listAllWorkspace?.length > 0) {
      const newOptions = listAllWorkspace.map(item => {
        return {
          key: item.id,
          label: item.name,
        };
      });
      setOptionWorkspace(newOptions);
    } else {
      setOptionWorkspace([]);
    }
  }, [listAllWorkspace]);

  const handleScrollWorkspace = event => {
    const clientHeight = event.target.clientHeight;
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    if (
      clientHeight + 10 - (scrollHeight - scrollTop) > 0 &&
      workspacecQueries.pageNumber <= totalWorkspacePages &&
      !loadingList
    ) {
      fetchListWorkspace({
        ...workspacecQueries,
        pageNumber: workspacecQueries.pageNumber + 1,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  const handleSearchKeyWorkspace = key => {
    if (key) {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        searchKeyName: key,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    } else {
      fetchListWorkspace({
        pageNumber: 1,
        pageSize: 10,
        isReset: true,
        statuses: ["ACTIVE"],
        sortFieldWorkspace: "createdTime",
      });
    }
  };

  useEffect(() => {
    if (
      userType === USER_TYPE.SUPER_ADMIN &&
      itemSelected &&
      itemSelected.workspace
    ) {
      setOptionWorkspace([
        {
          key: itemSelected.workspace.id,
          label: itemSelected.workspace.name,
        },
      ]);
    }
  }, [itemSelected]);

  const initValue = dataDetail => {
    if (dataDetail) {
      const provider = [];
      if (dataDetail?.provider) {
        Object.entries(dataDetail?.provider).forEach(([key]) => {
          // if (value) {
          switch (key) {
            case CHANNEL_PROVIDER.SMS.toLowerCase():
              provider.push(CHANNEL_PROVIDER.SMS);
              break;
            case CHANNEL_PROVIDER.MMS.toLowerCase():
              provider.push(CHANNEL_PROVIDER.MMS);
              break;
            case CHANNEL_PROVIDER.WhatsApp.toLowerCase():
              provider.push(CHANNEL_PROVIDER.WhatsApp);
              break;
            case CHANNEL_PROVIDER.Voice.toLowerCase():
              provider.push(CHANNEL_PROVIDER.Voice);
              break;
          }
          // }
        });
      }
      return {
        name: dataDetail?.name || CHANNEL_NAME.BULKSMS,
        provider: provider,
        apiKey: dataDetail?.apiKey,
        channelStatus: dataDetail?.status || CHANNEL_STATUS.ENABLED,
        workspace: dataDetail?.workspace?.id,
      };
    } else {
      return {
        name: CHANNEL_NAME.BULKSMS,
        channelStatus: CHANNEL_STATUS.ENABLED,
        provider: ["sms", "mms", "whatsapp", "voice"],
      };
    }
  };

  useEffect(() => {
    setIsView(isViewFrm);
  }, [isViewFrm]);

  useEffect(() => {
    if (itemSelected) {
      getDetailData().then(res => {
        setDataDetail(res.data);
        setLoadingData(false);
      });
    } else {
      setLoadingData(false);
    }
  }, [itemSelected]);

  const getDetailData = async () => {
    const { payload } = await dispatch(doGetChannelDetail(itemSelected.id));
    if (payload) {
      return payload;
    }
  };

  return (
    <div style={{ height: "100%" }}>
      {loadingData ? (
        <div style={{ margin: "auto 30px", textAlign: "center" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Form
          ref={formRef}
          initialValues={initValue(dataDetail)}
          layout={"vertical"}
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
        >
          <p style={frmStyle.labelTitle}>{t("label.channel")}</p>
          <Form.Item name="name" rules={[{ required: true }]}>
            <AppSelect
              options={channelNameOptions}
              disabled={isView}
            ></AppSelect>
          </Form.Item>

          <p className={styles.required} style={frmStyle.labelTitle}>
            {t("channel.provides")}
          </p>
          <Form.Item name="provider" rules={[{ required: true }]}>
            <AppSelect
              mode="multiple"
              options={providerOptions}
              disabled={true}
            ></AppSelect>
          </Form.Item>

          <div style={frmStyle.apiKeylabelTitle}>
            <p className={styles.required} style={frmStyle.labelTitle}>
              {t("channel.apiKey")}
            </p>
            <Link href="https://smsmanager.com.au/apikeys.php" target="_blank">
              {t("channel.bulkSMS")}
            </Link>
          </div>

          <Form.Item
            name="apiKey"
            rules={[
              { required: true },
              {
                pattern: new RegExp(PATTERNS.XSS_PATTERN),
                message: t("validate.noxss"),
              },
            ]}
            style={{
              marginBottom: itemSelected ? 0 : 24,
            }}
          >
            <Input placeholder={t("channel.apiKey")} disabled={isView} />
          </Form.Item>
          {itemSelected && itemSelected.apiKey && (
            <div
              style={{
                marginBottom: itemSelected ? 24 : 0,
              }}
            >
              <BulkSMSCreditBalance apiKey={itemSelected.apiKey} />
            </div>
          )}

          <p style={frmStyle.labelTitle}>{t("channel.status")}</p>
          <Form.Item name="channelStatus" rules={[{ required: true }]}>
            <AppSelect
              options={statusOptions}
              disabled={
                isView || (authInfo?.type === USER_TYPE.USER && itemSelected)
              }
            ></AppSelect>
          </Form.Item>

          {userType === USER_TYPE.SUPER_ADMIN && (
            <>
              <p style={frmStyle.labelTitle}>{t("channel.workspace")}</p>
              <Form.Item name="workspace">
                <SelectMultiple
                  type={"select-search"}
                  disabled={isView}
                  loading={loadingList}
                  showSearch
                  allowClear={false}
                  optionFilterProp="children"
                  options={workspaceOption}
                  onChange={value => {
                    formRef.current.setFieldsValue({
                      workspaceId: value,
                    });
                  }}
                  config={{
                    width: "100%",
                  }}
                  handleSearch={handleSearchKeyWorkspace}
                  handleScroll={handleScrollWorkspace}
                />
              </Form.Item>
            </>
          )}
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              justifyContent: "end",
              gap: "16px",
            }}
          >
            <AppButton
              label={t("button.cancel")}
              color={"grey"}
              loading={loading}
              htmlType="button"
              onClick={() => {
                onCancel();
              }}
            />
            {isView ? (
              <AppButton
                label={t("button.edit")}
                color={"blue"}
                loading={loading}
                type="primary"
                htmlType="button"
                onClick={() => {
                  onChangeViewFrm(false);
                }}
              />
            ) : (
              <AppButton
                label={itemSelected ? t("button.save") : t("button.add")}
                color={"blue"}
                loading={loading}
                type="primary"
                htmlType="submit"
              />
            )}
          </div>
        </Form>
      )}
    </div>
  );
};

const frmStyle = {
  apiKeylabelTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  labelTitle: {
    fontWeight: "bold",
    marginBottom: "6px",
  },
  lineHeightLg: {
    lineHeight: "1.2rem",
  },
  fontWeightBold: {
    fontWeight: "bold",
  },
};

export default ChannelForm;
